import { css } from '@emotion/react';

export const mt1 = css`
  margin-top: 4px;
`;
export const mt2 = css`
  margin-top: 8px;
`;
export const mt3 = css`
  margin-top: 12px;
`;
export const mt4 = css`
  margin-top: 16px;
`;
export const mt5 = css`
  margin-top: 20px;
`;

export const mr1 = css`
  margin-right: 4px;
`;
export const mr2 = css`
  margin-right: 8px;
`;
export const mr3 = css`
  margin-right: 12px;
`;
export const mr4 = css`
  margin-right: 16px;
`;
export const mr5 = css`
  margin-right: 20px;
`;

export const mb1 = css`
  margin-bottom: 4px;
`;
export const mb2 = css`
  margin-bottom: 8px;
`;
export const mb3 = css`
  margin-bottom: 12px;
`;
export const mb4 = css`
  margin-bottom: 16px;
`;
export const mb5 = css`
  margin-bottom: 20px;
`;

export const ml1 = css`
  margin-left: 4px;
`;
export const ml2 = css`
  margin-left: 8px;
`;
export const ml3 = css`
  margin-left: 12px;
`;
export const ml4 = css`
  margin-left: 16px;
`;
export const ml5 = css`
  margin-left: 20px;
`;
